module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_3009.3d3417a1.png";